import {Product, ProductState} from "@/modules/product/types";
import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {getProduct, getProducts} from "@/services/product";

export const state: ProductState = {
  product: {
    id: "",
    code: "",
    id_item_type: "",
    item_type: "",
    name: "",
    standard_price: "",
    quantity: 0,
    materials: [],
    MX: "",
    NALADI: "",
    NALADISA: ""
  }
}

const actions: ActionTree<ProductState, RootState> = {
  async GET_PRODUCTS(_, payload) {
    return await getProducts(payload);
  },
  async GET_PRODUCT(_, id) {
    return await getProduct(id);
  },
}

const mutations: MutationTree<ProductState> = {
  SET_PRODUCT(state, product: Product) {
    state.product = product;
  },
  RESET_PRODUCT(state) {
    state.product = {
      id: "",
      code: "",
      id_item_type: "",
      item_type: "",
      name: "",
      quantity: 0,
      materials: [],
      standard_price: "",
      MX: "",
      NALADI: "",
      NALADISA: ""
    }
  },
}

const getters: GetterTree<ProductState, RootState> = {
  PRODUCT(state): Product {
    const {product} = state;
    return {...product};
  }
}

export const product: Module<ProductState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
